export default __webpack_public_path__ + "static/media/androidstudio.db5ffb8a.png";